import Highway from '@dogstudio/highway';

export default class DefaultPageRenderer extends Highway.Renderer {

  onEnter() {

    this.DOM = { view: this.wrap.lastElementChild };

  }

}
